// Marketing site the logo points to on unauthenticated screens.
export const GLOBILISE_WEBSITE_URL = "https://globilise.com/";

export const PRIVACY_POLICY_PATH = "/privacy-policy";
export const TERMS_OF_SERVICE_PATH = "/terms-of-service";
